<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-2">
    <div class="col">
      <label i18n>Est</label>
      <select class="form-control" formControlName="ownershipConditions">
        <option
          *ngFor="let condition of ownershipConditions"
          [ngValue]="condition"
        >
          {{ getOwnershipConditionLabel(condition) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label>Nombre d'adultes</label>
      <input
        class="form-control"
        formControlName="adultCount"
        type="number"
        min="0"
      />
    </div>
    <div class="col">
      <label>Nombre d'enfants</label>
      <input
        class="form-control"
        formControlName="childrenCount"
        type="number"
        min="0"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label i18n>A un chien ?</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasDog"
          id="hasDogFalse"
          [value]="false"
          formControlName="hasDog"
        />
        <label class="form-check-label" for="hasDogFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasDog"
          id="hasDogTrue"
          [value]="true"
          formControlName="hasDog"
        />
        <label class="form-check-label" for="hasDogTrue"> Oui </label>
      </div>
    </div>
    <div *ngIf="metadataFormGroup.controls['hasDog'].value">
      <label i18n>Combien de chien ?</label>
      <input
        class="form-control"
        type="number"
        min="0"
        formControlName="dogCount"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label>Date de début d'assurance</label>
      <input
        class="form-control"
        [(ngModel)]="startDate"
        name="startDate"
        type="date"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>
  <div class="my-3">
    <ng-container formGroupName="placeType">
      <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
        Lieu de risque
      </div>
      <div class="row row-cols-md-2 row-cols-sm-1 my-2">
        <div class="col">
          <label i18n>Maison</label>
          <select formControlName="houseType" class="form-control">
            <option *ngFor="let type of houseTypes" [ngValue]="type">
              {{ getHouseTypeLabel(type) }}
            </option>
          </select>
        </div>
        <div class="col">
          <label i18n>Bâtiment</label>
          <select formControlName="buildingType" class="form-control">
            <option *ngFor="let type of buildingTypes" [ngValue]="type">
              {{ getBuildingTypeLabel(type) }}
            </option>
          </select>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n>Somme d'assurance</label>
          <input
            class="form-control"
            type="number"
            min="0"
            formControlName="amountToCover"
          />
        </div>
      </div>
      <div class="row row-cols-md-2 row-cols-sm-1">
        <div class="col-9">
          <label i18n>Adresse</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
        <div class="col-3">
          <label i18n>NPA</label>
          <input
            class="form-control"
            type="number"
            min="0"
            formControlName="postalCode"
          />
        </div>
      </div>
    </ng-container>
    <div class="row my-3">
      <div class="col">
        <label i18n>Nombre de pièces</label>
        <input
          class="form-control"
          type="number"
          min="0"
          step="0.5"
          formControlName="rooms"
        />
      </div>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Couvertures</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="getControl(metadataFormGroup.controls['covers'])"
          multiple
        >
          <mat-option *ngFor="let cover of covers" [value]="cover">{{
            getCoverLabel(cover)
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col">
      <label i18n>Couvertures complémentaires</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="
            getControl(metadataFormGroup.controls['additionalCovers'])
          "
          multiple
        >
          <mat-option *ngFor="let cover of additionalCovers" [value]="cover">{{
            getAdditionalCoverLabel(cover)
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Responsabilité civile privée</label>
      <select class="form-control" formControlName="civilLiability">
        <option
          *ngFor="let civilLiability of civilLiabilityValues"
          [ngValue]="civilLiability"
        >
          {{ getCivilLiabilityLabel(civilLiability) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-md-1 my-3">
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        class="form-control"
        formControlName="amountToCover"
        min="0"
      />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        class="form-control"
        formControlName="deductible"
        min="0"
      />
    </div>
  </div>
  <div class="mt-4 mb-3">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Questionnaire
    </div>
    <div class="row my-3">
      <div class="col">
        <label i18n
          >Est-il ou a-t-il été assuré pour les branches proposées ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="wasInsured"
            id="wasInsuredFalse"
            [value]="false"
            formControlName="wasInsured"
          />
          <label class="form-check-label" for="wasInsuredFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="wasInsured"
            id="wasInsuredTrue"
            [value]="true"
            formControlName="wasInsured"
          />
          <label class="form-check-label" for="wasInsuredTrue"> Oui </label>
        </div>
      </div>
    </div>
    <div
      class="row row-cols-md-2 row-cols-md-1"
      *ngIf="metadataFormGroup.controls['wasInsured'].value"
    >
      <div class="col">
        <label i18n>Nom de la compagnie</label>
        <input class="form-control" type="text" formControlName="oldCompany" />
      </div>
      <div class="col">
        <label i18n>N° de police</label>
        <input
          class="form-control"
          type="text"
          formControlName="policyNumber"
        />
      </div>
    </div>
    <div class="row my-3">
      <div class="col">
        <label i18n
          >A-t-il subi des sinistres dans les branches proposées ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="sufferedClaims"
            id="sufferedClaimsFalse"
            [value]="false"
            formControlName="sufferedClaims"
          />
          <label class="form-check-label" for="sufferedClaimsFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="sufferedClaims"
            id="sufferedClaimsTrue"
            [value]="true"
            formControlName="sufferedClaims"
          />
          <label class="form-check-label" for="sufferedClaimsTrue"> Oui </label>
        </div>
      </div>
    </div>
    <div class="row my-3">
      <div class="col">
        <label i18n
          >Une proposition d'assurance pour les branches proposées lui a-t-elle
          été refusée ou l'acceptation/la poursuite du contrat était-elle
          conditionnée à des conditions aggravées  ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="propositionRefused"
            id="propositionRefusedFalse"
            [value]="false"
            formControlName="propositionRefused"
          />
          <label class="form-check-label" for="propositionRefusedFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="propositionRefused"
            id="propositionRefusedTrue"
            [value]="true"
            formControlName="propositionRefused"
          />
          <label class="form-check-label" for="propositionRefusedTrue">
            Oui
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-container>
